import styled from 'styled-components';

export const Wrapper = styled.div`
  background: #f5f6f7;
  padding: 40px;
  flex: 1;
`;

export const PageRow = styled.div`
  margin-top: 12px;
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export const Column = styled.div`
  flex: 1;
`;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/components/wrapper.js